import { Navigate, useParams } from "react-router-dom";
import { cityHref, stateHref } from "@/lib/urls";

/**
 * Old `/cities/:slug` URL → 301-style redirect to new keyword-rich URL.
 * Uses replace so back-button doesn't re-trigger the redirect loop.
 */
export function RedirectCity() {
  const { slug } = useParams();
  return <Navigate to={cityHref(slug)} replace />;
}

export function RedirectState() {
  const { slug } = useParams();
  return <Navigate to={stateHref(slug)} replace />;
}

// Old /compare/* URLs → redirect to the matching blog post.
// (User feedback: comparisons should live as blogs, not standalone pages.)
const COMPARE_SLUG_TO_BLOG = {
  "smart-board-vs-digital-board": "smart-board-vs-digital-board",
  "benq-vs-maxhub": "benq-vs-maxhub-interactive-flat-panel",
  "interactive-flat-panel-vs-projector": "interactive-flat-panel-vs-projector",
  "65-vs-75-vs-86-inch": "65-vs-75-vs-86-inch-digital-board-size-guide",
};

export function RedirectCompare() {
  const { slug } = useParams();
  const blog = slug ? COMPARE_SLUG_TO_BLOG[slug] : null;
  return <Navigate to={blog ? `/blog/${blog}` : "/blog?category=comparison"} replace />;
}

export function RedirectCompareIndex() {
  return <Navigate to="/blog?category=comparison" replace />;
}

